import { render, staticRenderFns } from "./index-activity.vue?vue&type=template&id=6f046959&scoped=true"
import script from "./index-activity.vue?vue&type=script&lang=js"
export * from "./index-activity.vue?vue&type=script&lang=js"
import style0 from "./index-activity.vue?vue&type=style&index=0&id=6f046959&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f046959",
  null
  
)

export default component.exports